import { QuestionStatus } from '@exam-management/graphql';
import type { QBankStructureLevelItemWithLevel } from '@exam-management/qbs-provider';
import {
  LocationFields,
  LocationFormFields,
  LocationSectionWrapper,
} from '@exam-management/qcontent-management';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { PaperSection } from '@shared/components';

import { useSingleQuestionDetails } from '../../providers';
import type { QBankStructureLevelsForQuestionCreation } from '../../types';

interface LocationSectionProps {
  qbsLevelItems: QBankStructureLevelItemWithLevel[];
  qbsLevels: QBankStructureLevelsForQuestionCreation;
}

export default function LocationSection(props: Readonly<LocationSectionProps>) {
  const { qbsLevelItems, qbsLevels } = props;
  const { singleQuestion } = useSingleQuestionDetails();

  const { roles, status } = useQuestionCreationTaskDetails();

  const isInDevelopment = singleQuestion.status === QuestionStatus.InDevelopment;

  const isEditable =
    isInDevelopment &&
    roles.isAssignee &&
    status.code === QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress;

  return (
    <PaperSection title='Location'>
      <LocationSectionWrapper>
        {isEditable ? (
          <LocationFormFields
            prefix='location'
            qbsLevels={qbsLevels}
            qbsLevelItems={qbsLevelItems}
          />
        ) : (
          <LocationFields qbsLevels={qbsLevels} qbsLevelItems={qbsLevelItems} />
        )}
      </LocationSectionWrapper>
    </PaperSection>
  );
}
